export default __webpack_public_path__ + "static/media/ionic-ios-close-circle-outline.baff33e7.svg";